import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'

Vue.use(Vuex)

//let ApiUrl = "http://api.me/"
let ApiUrl = "https://api.mestav.com.tr/"

const store = new Vuex.Store({
  state: {
    access_token: "",
    refresh_token: "",
    Kullanici_id: "",
    KullaniciAdi: "",
  },

  mutations: {
    setToken(state, data) {
      state.access_token = data.Token.access_token;
      state.refresh_token = data.Token.refresh_token;
      state.Kullanici_id = data.Kullanici.id;
      state.KullaniciAdi = data.Kullanici.isim;
    },

    clearToken(state) {
      state.access_token = "";
      state.refresh_token = "";
      state.Kullanici_id = "";
      state.KullaniciAdi = "";
    }
  },

  actions: {
    initAuth({commit, dispatch}) {

      let token = JSON.parse(localStorage.getItem("_tuccar"))
      if (token) {
        commit("setToken", token)
        let Simdi = new Date().getTime()
        let Sures = token.Token.expires_in

        if (Simdi > +Sures) {
          //dispatch("logout");
        } else {
          let timerSecond = +Sures - Simdi
          //dispatch("logoutTime",timerSecond)
        }
      } else {
        //router.push("/giris")
        return false
      }

    },

    login({commit, dispatch, state}, data) {

      localStorage.removeItem("_tuccar");
      localStorage.removeItem("_tuccarisOturum");

      let BaseUrl = ApiUrl + data.mode + "/auth/";
      return axios.post(
        BaseUrl,
        {...data},

      ).then(response => {
        if (response.data.Status == 'OK') {
          if (data.mode == 'giris') {
            localStorage.setItem("_tuccar", JSON.stringify(response.data));
            localStorage.setItem("_tuccarisOturum", response.data.Kullanici.id);
            commit("setToken", response.data)
            //dispatch("logoutTime", new Date().getTime() + +response.data.Token.expires_in * 1000)
          }
        }
        return response.data;
      })

    },

    logout({commit}) {
      commit("clearToken")
      localStorage.removeItem("SBildirim");
      localStorage.removeItem("_tuccar");
      localStorage.removeItem("_tuccarisOturum");
      router.push("/giris")
    },

    logoutTime({dispatch}, expiresIn) {
      setTimeout(() => {
        dispatch("logout")
      }, expiresIn)
    },

    dataver({state}, params) {
      //console.log(state)
      return axios({
        method: params.method,
        url: ApiUrl + state.Kullanici_id + params.url,
        data: params.data,
      }).then(response => {
        return response.data;
      })
        /**
         * .catch(err => {
        this.commit("clearToken")
        localStorage.removeItem("SBildirim");
        localStorage.removeItem("_tuccar");
        localStorage.removeItem("_tuccarisOturum");
        //router.push("/giris")
        //console.log(err)
      });
         */

    },

    Delete({state}, data) {
      return axios({
        method: 'delete',
        url: ApiUrl + state.Kullanici_id + '/' + data.link + '/' + data.id,
        /*headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': state.access_token,
        }*/
      }).then(response => {
        return response.data;
      });
    },
  },

  getters: {
    isOturum(state, access_token) {
      let isOturum = localStorage.getItem('_tuccarisOturum');
      if (!isOturum) isOturum = state.Kullanici_id;
      return isOturum !== ""
    }
  },
})

export default store



// WEBPACK FOOTER //
// ./src/store.js